import http from '../../../assets/extra/_httpServices';
import { updateLoadingScreen } from '../../../redux/Actions';
import { urls } from '../../../components/common/constants';
import * as types from './UserActionType'

const updateRolesList = (data) => {
    return {
        type: types.ROLES_LIST,
        payload: data,
    }
}
const updateUserList = (data) => {
    return {
        type: types.USER_LIST,
        payload: data,
    }
}
const place_List = (data) => {
    return {
        type: types.PLACE_LIST,
        payload: data,
    }
}
const busStation_List = (data) => {
    return {
        type: types.BUSSTATION_LIST,
        payload: data,
    }
}

const updateCorporationList = (data) => {
    return {
        type: types.CORPORATION_LIST,
        payload: data,
    }
}

const updateDivFilter = (data) => {
    return {
        type: types.DIVISION_LIST,
        payload: data,
    }
}
const counters_filter = (data) => {
    return {
        type: types.COUNTERS_FILTER,
        payload: data,
    }
}
const updateDepotList = (data) => {
    return {
        type: types.DEPOT_LIST,
        payload: data,
    }
}
const updateBTobBToCUserAll = (data) => {
    return {
        type: types.BTOB_BTOC_USER_LIST,
        payload: data,
    }
}
const updateUserLevelList = (data) => {
    return {
        type: types.UPDATE_USER_LEVEL,
        payload: data,
    }
}
const updateDepartmentsList = (data) => {
    return {
        type: types.UPDATE_USER_DEPARTMENT,
        payload: data,
    }
}
//updateDepartmentsList
export const getRolesList = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.HttpGet(urls?.getRolesList, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateRolesList(response.data.Data.Table));
                } else {
                    dispatch(updateRolesList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updateRolesList([]))
            })
    }
}

export const getRoleTableData = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getRolesList, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}


export const getUserList = (params, isCache = false, cacheDuration = 0) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.GetRequestCached(urls?.getUserList, params, isCache, cacheDuration)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateUserList(response.data.Data.Table));
                } else {
                    dispatch(updateUserList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updateUserList([]))
            })
    }
}

export const getplaceListAll = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.HttpGet(urls?.getplaceListAll, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(place_List(response.data.Data.Table));
                } else {
                    dispatch(place_List([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(place_List([]))
            })
    }
}
export const getBusStationListAll = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.HttpGet(urls?.getBusStationListAll, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(busStation_List(response.data.Data.Table));
                } else {
                    dispatch(busStation_List([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(busStation_List([]))
            })
    }
}

export const userRoleInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.userRoleInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getCorporationList = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.HttpGet(urls?.getCorporationList, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateCorporationList(response.data.Data.Table));
                } else {
                    dispatch(updateCorporationList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updateCorporationList([]))
            })
    }
}

export const getUserManageTableData = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getUserList, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}

export const userManangeDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.userManangeDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const divisionFilterList = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.HttpGet(urls?.getdivisionFilterList, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateDivFilter(response.data.Data.Table));
                } else {
                    dispatch(updateDivFilter([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updateDivFilter([]))
            })
    }
}

export const CountersfilterList = (params) => {
    return (dispatch) => {
        http.HttpGet(urls?.getMasterCountersListAll, params)
            .then((response) => {
                if (response.status === 200 && response.data.status) {
                    dispatch(counters_filter(response.data.Data.Table));
                } else {
                    dispatch(counters_filter([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(counters_filter([]))
            })
    }
}

export const getDepotList = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.HttpGet(urls?.getDepotList, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateDepotList(response.data.Data.Table));
                } else {
                    dispatch(updateDepotList([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updateDepotList([]))
            })
    }
}


export const userManageInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.userManageInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getBTobBToCUserAll = (params) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.HttpGet(urls?.getBTobBToCUserAll, params)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateBTobBToCUserAll(response.data.Data.Table));
                } else {
                    dispatch(updateBTobBToCUserAll([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updateBTobBToCUserAll([]))
            })
    }
}

export const BToBBToCUserInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpCall(urls.BToBBToCUserInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getBToBBToCUserTableData = (params) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(updateLoadingScreen(true))
            http.HttpGet(urls?.getBTobBToCUserAll, params)
                .then((response) => {
                    dispatch(updateLoadingScreen(false));
                    return resolve(response)
                })
                .catch((error) => {
                    dispatch(updateLoadingScreen(false));
                    console.log("Error: ", error);
                })
        })
    }
}

export const BToBBToCUserDelete = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.BToBBToCUserDelete, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getLevelDepartmentsList = (params, isCache = false, cacheDuration = 0) => {
    return (dispatch) => {
        dispatch(updateLoadingScreen(true))
        http.GetRequestCached(urls?.getLevelDepartmentsList, params, isCache, cacheDuration)
            .then((response) => {
                dispatch(updateLoadingScreen(false))
                if (response.status === 200 && response.data.status) {
                    dispatch(updateUserLevelList(response.data.Data.Table));
                    dispatch(updateDepartmentsList(response.data.Data.Table1));

                } else {
                    dispatch(updateUserLevelList([]));
                    dispatch(updateDepartmentsList([]));

                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateLoadingScreen(false))
                dispatch(updateUserLevelList([]))
                dispatch(updateDepartmentsList([]));

            })
    }
}